import { V4SensorSettings } from 'custom_hooks/data_hooks/v4_sensor_settings/shared';

export function anyVibrationAxisEnabled(settings: V4SensorSettings): boolean {
    return settings.vibrationX || settings.vibrationY || settings.vibrationZ;
}
